import React, { useState, useCallback } from "react";
import ReportDetails from "./details";
import ReportsFilters from "./filters";

const ReportsComponent = () => {
  const [detailView, setDetailView] = useState(false);
  const [filters, setFilters] = useState([]);
  const [reportType, setReportType] = useState("");

  const showDetails = useCallback(() => {
    setDetailView(!detailView);
  }, [detailView]);

  const reportFilters = (filters) => {
    setFilters(filters);
  };

  const setRepType = (type) => {
    setReportType(type);
  };

  return !detailView ? (
    <ReportsFilters
      showDetails={showDetails}
      reportFilters={reportFilters}
      setReportType={setRepType}
    />
  ) : (
    <ReportDetails
      showDetails={showDetails}
      filters={filters}
      reportType={reportType}
    />
  );
};

export default ReportsComponent;
